module.exports = __webpack_public_path__ + "img/12.844f646d.jpg";